function ReviewBusinessPage({
  businessName,
  description,
  experience,
  address,
  businessLogoPreview,
  agentProfilePreview,

  selectedReligion,
  selectedCaste,
  selectedCommunities,
  selectedLanuages,

  Email,
  PhoneNumber,
  agentName,

  promoImagePreviews,

  pricingModel,
  pricingAmount,
  paymentMethods,

  prevStep,
  nextStep,
  ReligionOptions,
  CasteOptions,
  CommunitiesOptions,
  LanguageOptions,
  selectedCountryCode,
}) {
  return (
    <div className="review-page-main mt-4">
      {/* TOP TITLE */}

      {/* MAIN CARD */}

      <div className="review-main-card">
        <div className="review-title-section">
          <h2>Review your agency page</h2>

          <div className="review-title-line"></div>
        </div>

        {/* TOP PROFILE SECTION */}

        <div className="review-profile-card">
          <div className="d-flex align-items-center justify-content-center align-items-center gap-3">
            {businessLogoPreview ? (
              <img
                src={businessLogoPreview}
                alt=""
                className="review-logo-circle"
              />
            ) : (
              <img
                src={require("../../assests/images/default_busi_logo.png")}
                className="review-logo-circle"
              />
            )}

            <h1> {businessName || "Business Name"}</h1>
          </div>

          <p className="review-tagline">For your forever</p>

          <div className="review-stars">★ ★ ★ ★ ☆</div>

          {/* <p className="review-website">www.ajmatrimony.com</p> */}

          <div className="review-top-info">
            <div> 📍 {address || "Address"} </div>

            <div> 🕒 {experience || 0} years</div>

            <div> 🌐 {selectedLanuages?.join(", ")}</div>
          </div>
        </div>

        {/* ABOUT */}

        <div className="review-about-section">
          <h3>About</h3>

          <p>{description || "No description added"}</p>
        </div>

        {/* IMAGES */}

        {/* PROMOTIONAL IMAGES */}

        {promoImagePreviews?.length > 0 && (
          <div className="review-images-row">
            {promoImagePreviews.map(({ preview }, index) => (
              <img key={index} src={preview} alt={`promo-${index}`} />
            ))}
          </div>
        )}

        {/* DETAILS */}

        <div className="review-detail-grid">
          {/* LEFT */}

          <div className="review-detail-card">
            <h3>Service Details</h3>

            {/* RELIGIONS */}

            <div className="review-section">
              <p className="review-label">Religions</p>

              <div className="review-pill-row">
                {(selectedReligion.includes("all")
                  ? [{ label: "All Religions" }]
                  : ReligionOptions.filter((o) =>
                      selectedReligion.includes(o.value),
                    )
                ).map((item, index) => (
                  <div className="review-pill" key={index}>
                    {item.label}
                  </div>
                ))}
              </div>
            </div>

            {/* CASTES */}

            <div className="review-section">
              <p className="review-label">Castes</p>

              <div className="review-pill-row">
                {(selectedCaste.includes("all")
                  ? [{ label: "All Castes" }]
                  : CasteOptions.filter((o) => selectedCaste.includes(o.value))
                ).map((item, index) => (
                  <div className="review-pill" key={index}>
                    {item.label}
                  </div>
                ))}
              </div>
            </div>

            {/* COMMUNITIES */}

            <div className="review-section">
              <p className="review-label">Communities</p>

              <div className="review-pill-row">
                {(selectedCommunities.includes("all")
                  ? [
                      {
                        label: "All Communities",
                      },
                    ]
                  : CommunitiesOptions.filter((o) =>
                      selectedCommunities.includes(o.value),
                    )
                ).map((item, index) => (
                  <div className="review-pill" key={index}>
                    {item.label}
                  </div>
                ))}
              </div>
            </div>

            {/* LANGUAGES */}

            <div className="review-section">
              <p className="review-label">Language communities serve</p>

              <div className="review-pill-row">
                {(selectedLanuages.includes("all")
                  ? [
                      {
                        label: "All Languages",
                      },
                    ]
                  : LanguageOptions.filter((o) =>
                      selectedLanuages.includes(o.value),
                    )
                ).map((item, index) => (
                  <div className="review-pill" key={index}>
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT */}

          <div className="review-detail-card">
            <h3>Pricing details</h3>

            <div className="review-price-section">
              <p className="review-label">Pricing Model</p>

              <h4>{pricingModel || "One time payment"}</h4>
            </div>

            <div className="review-price-section">
              <p className="review-label">Pricing and payment details</p>

              <h4>{pricingAmount || "$12 per 15 matches"}</h4>
            </div>

            <div className="review-price-section">
              <p className="review-label">Supported payment methods</p>

              <div className="review-pill-row">
                {paymentMethods?.length > 0 ? (
                  paymentMethods.map((item, index) => (
                    <div className="review-pill" key={index}>
                      {item.label || item}
                    </div>
                  ))
                ) : (
                  <span>No payment methods selected</span>
                )}
              </div>
            </div>

            <p className="review-note">
              *Those prices are set by the agent for their services independent
              of Wedluk. Wedluk does not collect or cancel these fees.
            </p>
          </div>
        </div>

        {/* CONTACT */}

        <div className="review-contact-section">
          <h3>Contact agency</h3>

          <div className="review-contact-grid">
            <div>
              <img
                className="review-contact-icon"
                src={require("../../assests/images/contect-info.png")}
              />
              <>
                {selectedCountryCode && `+${selectedCountryCode} `}
                {PhoneNumber}
              </>
            </div>

            <div>
              {" "}
              <img
                className="review-contact-icon"
                src={require("../../assests/images/email-icon.png")}
              />{" "}
              {Email}
            </div>
          </div>
          <div className="review-contact-address">
            <img
              className="review-contact-icon"
              src={require("../../assests/images/address-icon.png")}
            />
            <div className="review-address">{address}</div>
          </div>
        </div>
      </div>

      {/* FOOTER */}

      <div className="review-footer">
        <button className="review-back-btn" onClick={prevStep}>
          ‹ Go back to edit
        </button>

        <button className="review-confirm-btn" onClick={nextStep}>
          Confirm & Finish registration ›
        </button>
      </div>
    </div>
  );
}

export default ReviewBusinessPage;
